module.exports = __webpack_public_path__ + "files/0ac16139d75d93fb954b5a0d07e0264b.png";